import { render, staticRenderFns } from "./merchantManage.vue?vue&type=template&id=3a1c4880&scoped=true"
import script from "./merchantManage.vue?vue&type=script&lang=js"
export * from "./merchantManage.vue?vue&type=script&lang=js"
import style0 from "./merchantManage.vue?vue&type=style&index=0&id=3a1c4880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c4880",
  null
  
)

export default component.exports